/**
 * @param car
 * @param country
 * @param carType
 * @param carNumber
 * @param userType
 * @param startDate
 * @param periodOption
 * @param moduleId
 * @returns {*|AxiosPromise}
 */
export function list(car, country, carType, carNumber, userType, startDate, periodOption, moduleId = null)
{

  return axios({
    url: '/api/' + process.env.VUE_APP_SERVER_MODE + '/insurance/greencard/calculator',
    method: 'post',
    data: {
      car: car,
      country: country,
      carType: carType,
      carNumber: carNumber,
      userType: userType,
      startDate: startDate,
      periodOption: periodOption,
      moduleId: moduleId,
    },
  });
}
